import React from 'react'

import { NextScheduleCard } from "./NextScheduleCard"
import { NextScheduleCTA } from "./NextScheduleCTA"
import { useIsPatientAllowedToSchedule } from 'hooks/useIsPatientAllowedToSchedule'
import { Card, Spinner } from '@telavita-core/react-design-kit'

import * as S from './styles'

const EmptyCard = () => {
  return (
    <Card customClassName='PatientHome__Card' variant='regular'>
      <S.SpinnerWrapper>
        <Spinner />
      </S.SpinnerWrapper>
    </Card>
  )
}

export const NextScheduleWrapper = () => {
  const handleOpenNewScheduleModal = () => {
    document.getElementById('float_action_button_dropdown')?.click()
  }

  const { 
    isLoading,
    refetchData,
    nextSchedule,
    isPatientAllowedToSchedule
  } = useIsPatientAllowedToSchedule(null)
  
  function handleRenderNextScheduleCard() {
    if (isLoading) {
      return <EmptyCard />
    }

    if (isPatientAllowedToSchedule) {
      return <NextScheduleCTA onClick={handleOpenNewScheduleModal} />
    }

    return (
      <NextScheduleCard
        schedule={nextSchedule}
        loading={isLoading}
        getNextSchedule={refetchData}
      />
    )
  }

  return (
    <div>
      {handleRenderNextScheduleCard()}
    </div>
  )
}